import { Component, OnInit, Input } from '@angular/core';

import { VismaService } from '../visma.service'
import { XpService } from '../xp.service'

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.scss']
})
export class AuthorizeComponent implements OnInit {
  @Input() part: any
  @Input() site: string

  url: string
  login: boolean

  constructor(private xp: XpService, private visma: VismaService) {  }

  ngOnInit() {
console.log(this.site)
    this.visma.getConfig({ site: this.site }).subscribe((Config: any) => {
      this.url = `${Config.identity}?` +
        `client_id=${Config.client_id}&` + 
        `redirect_uri=${Config.redirect_uri}&` +
        `scope=ea:api%20offline_access%20ea:sales&` +
        `state=1234567890&` +
       `response_type=code&` +
        `prompt=login&` +
        `acr_values=service:44643EB1-3F76-4C1C-A672-402AE8085934`
      console.log(this.url)
    })
  }

}
